import React from 'react';
import {SingleMappingSelect} from '../../../../../lib/components/select/base/SingleMappingSelect';

export interface RightSideOption {
  index: string,
  label: string;
}

function getOptionValue(option: RightSideOption) {
  return option.index;
}

function getOptionLabel(option: RightSideOption) {
  return option.label;
}

export class RightSideSelect extends React.Component<{
  options: readonly RightSideOption[],
  value: string | null,
  onChange: (index: string | null) => void,
  isDisabled?: boolean
}> {
  render() {
    return (
      <SingleMappingSelect<RightSideOption, string>
        options={this.props.options}
        getValue={getOptionValue}
        getLabel={getOptionLabel}
        value={this.props.value}
        onChange={this.props.onChange}
        isDisabled={this.props.isDisabled}/>);
  }
}
